<a
  [href]="href()"
  [target]="target() || '_self'"
  class="block-link card"
  [class.has--background]="imageUrl() && !videoUrl() && !text()"
  [class.no--background]="!imageUrl()"
  [class.has--link]="href() && !videoUrl() && !text()"
  [class.is--vlog]="videoUrl()"
  [class.is--blog]="text()"
  [ngClass]="'is--' + size()"
>
  <div class="card__inner">
    <div class="sr-only">{{ title() }}</div>
    @if (imageUrl() && !text()) {
      <figure class="card__figure">
        <img [src]="imageUrl()! | resize: 500 : 400 : imageAnchor()" [alt]="title()" />
        @if (videoUrl()) {
          <fstr-icon [ariaHidden]="true" [anchor]="'icon-play'"></fstr-icon>
        }
      </figure>
    }
    <header class="card__header" [class.has--footer]="showTime() || date()">
      <div>
        <h1 class="h6 card__title">{{ title() }}</h1>
        @if (subTitle()) {
          <h2 class="h6 type-body-xs mt-1 card__title text-primary">{{ subTitle() }}</h2>
        }
      </div>

      <span class="button button-icon button-icon--primary button--xs">
        <fstr-icon [ariaHidden]="true" anchor="icon-arrow-right"></fstr-icon>
      </span>
    </header>
    @if (text()) {
      <div class="card__content">
        @if (imageUrl() && text()) {
          <figure class="card__figure">
            <img [src]="imageUrl()! | resize: 500 : 400 : imageAnchor()" [alt]="title()" />
            @if (videoUrl()) {
              <fstr-icon [ariaHidden]="true" [anchor]="'icon-play'"></fstr-icon>
            }
          </figure>
        }
        <p class="text-muted">{{ text() }}</p>
      </div>
    }
    <footer class="card__footer">
      @if (date() && showDate()) {
        <span class="button button-with-icon" [ngClass]="{ 'button-with-icon--muted': !imageUrl(), 'button-with-icon--light': imageUrl() }">
          <fstr-icon [ariaHidden]="true" anchor="icon-calendar"></fstr-icon>
          <span>{{ date() | date: 'd MMMM y' }}</span>
        </span>
      }
      @if (author()) {
        <span
          class="button button-with-icon pointer-event-none"
          [ngClass]="{ 'button-with-icon--muted': !imageUrl(), 'button-with-icon--light': imageUrl() }"
        >
          <fstr-icon [ariaHidden]="true" anchor="icon-author"></fstr-icon>
          <span>{{ author() }}</span>
        </span>
      }
      @if (showTime()) {
        <span
          class="button button-with-icon"
          [ngClass]="{ 'button-with-icon--muted': !imageUrl() && !videoUrl(), 'button-with-icon--light': imageUrl() }"
        >
          <fstr-icon [ariaHidden]="true" anchor="icon-clock"></fstr-icon>
          <span>{{ date() | date: 'HH:mm' }}</span>
        </span>
      }
    </footer>
  </div>
</a>
